export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14715.b49fb430.jpg";